import * as React from 'react'
import * as T from 'components/ui/typography'
import Image from 'next/image'

import OutlinedBox from 'components/shared/outlined-box'

const BoxEmptySimulations = (props: PropsBoxEmptySimulations) => {
    return (
        <OutlinedBox className="py-2 flex flex-1 items-center w-full md:w-8/12">
            <div className="px-2 flex items-center">
                <Image src="/images/simulations-empty-state.svg" alt="empty_state" width={80} height={80} />
            </div>
            <div className="pr-1 flex flex-col justify-center">
                <T.Large className="text-lg">{props.title}</T.Large>
                <T.Muted>{props.subtitle}</T.Muted>
            </div>
        </OutlinedBox>
    )
}

export default BoxEmptySimulations
